import { Box } from '@mui/material'
import { useContext, useEffect, useState } from 'react'

// components
import { useSearchParams } from 'react-router-dom'
import { AppContext } from '../../../context'
import { GRAPHQL_QUERY_POLICY, PAGE_LIMIT, QUERY_PARAMS } from '../../../constants'
import { ActionType } from '../../../context/AppContextReducer'
import { ContentHead } from '../../common/ContentHead'
import { CardBox } from '../../../theme/styleComponents'
import { flexCenter } from '../../../theme/styleConstants'
import { EmptyData } from '../../common/EmptyData'

import { FetchReconciliationsQuery, useFetchReconciliationsLazyQuery } from '../../../../generated'
import { Alert } from '../../common/Alert'
import dayjs from 'dayjs'
import ReconciliationFilters from './ReconciliationFilters'
import ReconciliationsHistoryListing from './ReconciliationsHistoryListing'

const BankReconciliationSubitemHistory = () => {
  const [searchParams] = useSearchParams()
  const { currentPage, dispatch } = useContext(AppContext)
  const [reconciliations, setReconciliations] =
    useState<FetchReconciliationsQuery['fetchReconciliations']['reconciliations']>()
  const accountId = searchParams.get(QUERY_PARAMS.ACCOUNT_ID)
  const statementMonth = searchParams.get(QUERY_PARAMS.STATEMENT_MONTH)
  const reconciliationStatus = searchParams.get(QUERY_PARAMS.RECONCILIATION_STATUS)

  const [fetchReconciliations, { loading: reconciliationsLoading, refetch: refetchReconciliations }] =
    useFetchReconciliationsLazyQuery({
      ...GRAPHQL_QUERY_POLICY,
      variables: undefined,
      onError(error) {
        Alert.error(error.message)
      },
      onCompleted(data) {
        const { fetchReconciliations } = data || {}
        const { reconciliations, pagination } = fetchReconciliations || {}
        setReconciliations(reconciliations)

        if (pagination) {
          const { totalPages, totalCount } = pagination
          dispatch({ type: ActionType.SET_TOTAL_PAGE_COUNT, totalPageCount: totalPages || 1 })
          dispatch({ type: ActionType.SET_TOTAL_DATA_COUNT, totalDataCount: totalCount || 1 })
        }
      }
    })

  useEffect(() => {
    fetchReconciliations({
      variables: {
        fetchAllReconciliationInput: {
          paginationOptions: {
            page: currentPage,
            limit: PAGE_LIMIT
          },
          reverted: reconciliationStatus === 'reverted' ? true : false,
          ...(!!accountId && { accountId }),
          ...(!!statementMonth && { monthOfYear: dayjs(statementMonth).startOf('month').format('YYYY-MM-DD') })
        }
      }
    })
  }, [accountId, statementMonth, currentPage, reconciliationStatus])

  const isEmpty = reconciliations?.length === 0

  return (
    <CardBox marginTop={3}>
      <ContentHead title={'Bank Reconciliation History'} />

      <Box display={'flex'} flex={1} justifyContent={'space-between'} alignItems={'center'} m={2}>
        <ReconciliationFilters />
      </Box>

      {isEmpty ? (
        <Box sx={{ ...flexCenter, height: 'calc(100vh - 400px)' }}>
          <EmptyData title={'No Bank Reconciliation History Recorded!'} />
        </Box>
      ) : (
        <ReconciliationsHistoryListing
          reconciliations={reconciliations}
          refetch={refetchReconciliations}
          loading={reconciliationsLoading}
        />
      )}
    </CardBox>
  )
}

export default BankReconciliationSubitemHistory
